var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeteleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.577,
    height: 17.31,
    viewBox: "0 0 15.577 17.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M225.96,393.806a.626.626,0,0,1,.617.635v.329a.632.632,0,0,1-.617.635H211.618a.632.632,0,0,1-.618-.635v-.329a.626.626,0,0,1,.618-.635h2.523a1.11,1.11,0,0,0,1.074-.878l.132-.59A1.72,1.72,0,0,1,217,391h3.574a1.719,1.719,0,0,1,1.644,1.3l.141.632a1.109,1.109,0,0,0,1.074.879Zm-1.282,12.021c.26-2.455.724-8.288.724-8.347a.64.64,0,0,0-.157-.483.628.628,0,0,0-.453-.2h-12a.613.613,0,0,0-.453.2.684.684,0,0,0-.164.483c0,.011.018.216.046.56.123,1.526.465,5.776.686,7.789a2.524,2.524,0,0,0,2.536,2.446c1.087.025,2.206.034,3.351.034,1.078,0,2.173-.009,3.288-.034a2.525,2.525,0,0,0,2.6-2.448Z",
    transform: "translate(-211 -391)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeteleIcon);
export default __webpack_public_path__ + "static/media/detele-icon.42f8184b87243458fcd829ebaceee334.svg";
export { ForwardRef as ReactComponent };